<!-- Skeleton for UserBadge -->
<div class="user-badge-skeleton" *ngIf="NameOftheScreen=='userBadge'">
  <div class="ub-skel-banner skeleton"></div>
  <div class="ub-skel-avatar-wrap">
    <div class="ub-skel-avatar skeleton"></div>
  </div>
  <div class="ub-skel-body">
    <div class="ub-skel-name skeleton"></div>
    <div class="ub-skel-title skeleton"></div>
    <div class="ub-skel-location skeleton"></div>
    <div class="ub-skel-stats">
      <div class="ub-skel-stat-box skeleton"></div>
      <div class="ub-skel-stat-box skeleton"></div>
      <div class="ub-skel-stat-box skeleton"></div>
    </div>
    <div class="ub-skel-plan skeleton"></div>
    <div class="ub-skel-completeness skeleton"></div>
    <div class="ub-skel-endorsements skeleton"></div>
    <div class="ub-skel-member-since skeleton"></div>
  </div>
</div>
<!-- Skeleton for Post Component-->
<!-- Defaul post 1 -->
<div class="postPagecssdesgin" *ngIf="NameOftheScreen=='postPage'">
  <div class="skeleton-container">
    <div class="logo-skeleton ">
      <div class="logo-icon-skeleton  skeleton "></div>
      <div class="logo-text-skeleton "></div>
    </div>
    <div class="skeleton-heading skeleton "></div>
    <div class="skeleton-text skeleton "></div>
    <div class="skeleton-text skeleton "></div>
    <div class="content-skeleton ">
      <div class="text-skeleton skeleton "></div>
      <div class="skeleton-button skeleton "></div>
    </div>
  </div>
</div>
<!-- Defaul post 2 -->
<div class="postPagecssdesgin height-secondcard" *ngIf="NameOftheScreen=='postPage'">
  <div class="skeleton-container">
    <div class="logo-skeleton ">
      <div class="logo-icon-skeleton skeleton"></div>
      <div class="logo-text-skeleton "></div>
    </div>
    <div class="skeleton-subheading skeleton "></div>
    <div class="skeleton-heading skeleton "></div>
    <div class="skeleton-text skeleton "></div>
    <div class="skeleton-text skeleton "></div>
    <div class="skeleton-text skeleton "></div>
    <div class="skeleton-text skeleton "></div>
  </div>
</div>
<!-- Widgets -->
<div class=" widgetsPage candidates-container" *ngIf="NameOftheScreen=='widgets'">
  <div class="candidates-header">
    <div class="skeleton header-title skeleton "></div>
    <div class="skeleton header-icon skeleton "></div>
  </div>
  <div class="candidates-list">
    <div class="candidate-skeleton ">
      <div class="skeleton profile-pic skeleton "></div>
      <div class="candidate-info">
        <div class="skeleton candidate-name skeleton "></div>
        <div class="skeleton candidate-role skeleton "></div>
      </div>
    </div>
    <div class="candidate-skeleton ">
      <div class="skeleton profile-pic skeleton"></div>
      <div class="candidate-info">
        <div class="skeleton candidate-name skeleton "></div>
        <div class="skeleton candidate-role skeleton "></div>
      </div>
    </div>
    <div class="candidate-skeleton ">
      <div class="skeleton profile-pic skeleton "></div>
      <div class="candidate-info">
        <div class="skeleton candidate-name skeleton "></div>
        <div class="skeleton candidate-role skeleton "></div>
      </div>
    </div>
  </div>
  <div class="skeleton more-link"></div>
</div>
<div class="landingPagesidenavbar" *ngIf="NameOftheScreen=='landingPagesidenavbar'">
  <div class="sidebar-skeleton ">
    <div class="menu-item-skeleton ">
      <div class="icon-skeleton skeleton "></div>
      <div class="text-skeleton skeleton "></div>
    </div>
    <div class="menu-item-skeleton ">
      <div class="icon-skeleton skeleton "></div>
      <div class="text-skeleton skeleton "></div>
    </div>
    <div class="menu-item-skeleton ">
      <div class="icon-skeleton skeleton "></div>
      <div class="text-skeleton skeleton "></div>
    </div>
    <div class="menu-item-skeleton ">
      <div class="icon-skeleton skeleton "></div>
      <div class="text-skeleton skeleton "></div>
    </div>
    <div class="menu-item-skeleton ">
      <div class="icon-skeleton skeleton "></div>
      <div class="text-skeleton skeleton "></div>
    </div>
  </div>
</div>
<div class="video-card-ui-design" *ngIf="NameOftheScreen=='helpModule'">
  <div class="video-card-skeleton ">
    <div class="thumbnail-skeleton skeleton "></div>
    <div class="info-bar-skeleton ">
      <div class="title-skeleton skeleton "></div>
      <div class="duration-skeleton skeleton "></div>
    </div>
  </div>
  <!-- <div class="video-card-skeleton ">
    <div class="thumbnail-skeleton skeleton "></div>
    <div class="info-bar-skeleton ">
      <div class="title-skeleton skeleton "></div>
      <div class="duration-skeleton skeleton "></div>
    </div>
  </div>
  <div class="video-card-skeleton ">
    <div class="thumbnail-skeleton skeleton "></div>
    <div class="info-bar-skeleton ">
      <div class="title-skeleton skeleton "></div>
      <div class="duration-skeleton skeleton "></div>
    </div>
  </div> -->
</div>
<div class="jobcardui-design" *ngIf="NameOftheScreen=='jobcardMediumscreen'">
  <ng-container *ngFor="let item of countforView | times; let i = index">
    <div class="job-card-skeleton ">
      <div class="top-section">
        <div class="avatar-skeleton  skeleton "></div>
        <div class="info-skeleton ">
          <div class="name-skeleton skeleton "></div>
          <div class="title-skeleton skeleton "></div>
          <div class="details-skeleton skeleton "></div>
          <div class="salary-skeleton skeleton "></div>
        </div>
        <div class="status-skeleton "></div>
      </div>
      <div class="actions-skeleton ">
        <div class="button-skeleton skeleton "></div>
        <div class="button-skeleton skeleton "></div>
        <div class="button-skeleton skeleton "></div>
        <div class="button-skeleton skeleton "></div>
      </div>
    </div>
  </ng-container>
</div>
<div class="jobselectedMidscreen" *ngIf="NameOftheScreen=='jobselectedscreen'">
  <div class="job-details-skeleton">
    <div class="header-skeleton">
      <div class="avatar-skeleton skeleton"></div>
      <div class="info-skeleton">
        <div class="name-skeleton skeleton"></div>
        <div class="role-skeleton skeleton"></div>
        <div class="location-skeleton skeleton"></div>
      </div>
    </div>
    <div class="action-items  skeleton"></div>
    <div class="title-skeleton skeleton"></div>
    <div class="job-info-skeleton">
      <div class="id-skeleton skeleton"></div>
      <div class="salary-skeleton skeleton"></div>
      <div class="details-skeleton skeleton"></div>
    </div>
    <div class="job-info-skeleton">
      <div class="id-skeleton skeleton"></div>
      <div class="salary-skeleton skeleton"></div>
      <div class="details-skeleton skeleton"></div>
    </div>
    <div class="section-skeleton skeleton"></div>
    <div class="section-skeleton skeleton"></div>
    <div class="description-skeleton skeleton"></div>
  </div>
</div>
<!-- countforView = number of incoming/outgoing bubble PAIRS (was 3 static
     pairs; loop-driven so height-constrained hosts, e.g. the slider's
     embedded Chat tab, can request fewer rows). -->
<div class="message-widget-conversation-load" *ngIf="NameOftheScreen=='messageConversation'">
  <div class="chat-container-skeleton">
    <ng-container *ngFor="let pair of conversationPairs">
      <div class="chat-bubble-skeleton incoming">
        <div class="avatar-skeleton skeleton"></div>
        <div class="text-skeleton skeleton"></div>
        <div class="timestamp-skeleton skeleton"></div>
      </div>
      <div class="chat-bubble-skeleton-right outgoing">
        <div class="avatar-skeleton skeleton"></div>
        <div class="text-skeleton skeleton"></div>
        <div class="timestamp-skeleton skeleton"></div>
      </div>
    </ng-container>
  </div>
</div>
<div class="userChatDesign" *ngIf="NameOftheScreen=='userChat'">
  <div class="contact-list-skeleton">
    <div class="contact-skeleton">
      <div class="avatar-skeleton"></div>
      <div class="info-skeleton">
        <div class="name-skeleton"></div>
        <div class="details-skeleton"></div>
      </div>
    </div>
    <div class="contact-skeleton">
      <div class="avatar-skeleton"></div>
      <div class="info-skeleton">
        <div class="name-skeleton"></div>
        <div class="details-skeleton"></div>
      </div>
    </div>
    <div class="contact-skeleton">
      <div class="avatar-skeleton"></div>
      <div class="info-skeleton">
        <div class="name-skeleton"></div>
        <div class="details-skeleton"></div>
      </div>
    </div>
    <div class="contact-skeleton">
      <div class="avatar-skeleton"></div>
      <div class="info-skeleton">
        <div class="name-skeleton"></div>
        <div class="details-skeleton"></div>
      </div>
    </div>
    <div class="contact-skeleton">
      <div class="avatar-skeleton"></div>
      <div class="info-skeleton">
        <div class="name-skeleton"></div>
        <div class="details-skeleton"></div>
      </div>
    </div>
  </div>
</div>
<!--  Common loader  -->
<div class="loader-mini-size" *ngIf="NameOftheScreen=='CheckboxSelection'">
  <div class="loader-overlay">
    <div class="loader-circle"> </div>
  </div>
</div>
<div class="vertical-loader-mini-size" *ngIf="NameOftheScreen=='verticalCheckboxSelection'">
  <div class="loader-overlay">
    <div class="loader-circle"> </div>
  </div>
</div>
<div class="Notification" *ngIf="NameOftheScreen=='notification'">
  <ng-container *ngFor="let item of countforView | times; let i = index">
    <div class="notification-card-skeleton">
      <div class="avatar-skeleton"></div>
      <div class="text-skeleton full-width"></div>
      <div class="text-skeleton short-width"></div>
    </div>
  </ng-container>
</div>
<div class="connectionscard" *ngIf="NameOftheScreen=='connections'">
  <!-- <ng-container *ngFor="let item of countforView | times; let i = index">
  </ng-container> -->
  <div class="contact-card-skeleton">
    <div class="flex">
      <div class="avatar-skeleton"></div>
      <div class="sendmsg-skeleton"></div>
    </div>
  </div>
</div>
<div class="faq" *ngIf="NameOftheScreen=='faq'">
  <div class="faq-skeleton">
    <div class="faq-item-skeleton" *ngFor="let item of countforView | times; let i = index">
      <div class="text-skeleton"></div>
      <div class="arrow-skeleton"></div>
    </div>
  </div>
</div>
<div class="pricing" *ngIf="NameOftheScreen=='pricing'">
  <div class="pricing-page-skeleton">
    <!-- <div class="header-pricecard ">
      <div class="header-skeleton h-30 header-pricecard flex itemcenter">
        <div class="headerpage-button"></div>
        <div class="headerpage-button"></div>
      </div>
    </div> -->
    <div class="plan-cards-skeleton  ">
      <div class="plan-card-skeleton" *ngFor="let item of 4 | times; let i = index">
        <div class="button-skeleton skeleton"></div>
        <div class="text-skeleton medium skeleton"></div>
        <div class="text-skeleton small skeleton"></div>
        <div class="text-skeletonstartat skeleton"></div>
        <div class="button-skeleton skeleton"></div>
        <div class="button-skeleton yearmonth skeleton"></div>
        <div class="button-skeleton upgrade skeleton"></div>
        <div class="number-list-skeleton ">
          <div class="skeleton-block skeleton"></div>
          <hr class="skeleton-divider skeleton">
          <div class="skeleton-block skeleton"></div>
          <hr class="skeleton-divider skeleton">
          <div class="skeleton-block skeleton"></div>
          <hr class="skeleton-divider skeleton">
          <div class="skeleton-block skeleton"></div>
          <hr class="skeleton-divider skeleton">
          <div class="skeleton-block skeleton"></div>
        </div>
      </div>
    </div>
    <!-- <div class="table-skeleton">
      <div class="text-skeleton pricedummycard-ui"></div>
      <div class="text-skeleton pricedummycard-ui"></div>
      <div class="text-skeleton pricedummycard-ui"></div>
    </div> -->
  </div>
</div>
<!-- job row, viewSize 'business-row' (business Jobs page). Mirrors app-jobs .bjr-row:
     one 38px line, 12px top/bottom, 1px divider. -->
<div class="bjr-skel" *ngIf="NameOftheScreen=='jobrowBusiness'">
  <div class="bjr-skel-row" *ngFor="let item of countforView | times">
    <div class="bjr-skel-l1">
      <div class="bjr-skel-info">
        <span class="bjr-sk bjr-skel-title"></span>
        <span class="bjr-sk bjr-skel-meta"></span>
      </div>
      <span class="bjr-sk bjr-skel-pill"></span>
      <span class="bjr-sk bjr-skel-btn"></span>
      <span class="bjr-sk bjr-skel-btn"></span>
    </div>
  </div>
</div>
<div class="jobcardlarge" *ngIf="NameOftheScreen=='jobcardlarge'">
  <div class="card-1" *ngFor="let item of countforView | times; let i = index">
    <div class="avatar-section-1">
      <div class="avatar-1">
        <div class="avatar-text-1"></div>
        <!-- <div class="dc-tag-1">DC</div> -->
      </div>
    </div>

    <div class="content-1">
      <div class="header-1">
        <div class="title-area-1">
          <div class="title-1"></div>
          <div class="info-row-1">
            <div class="info-pill-1 exp-1"></div>
            <div class="info-pill-1 tech-1"></div>
          </div>
          <div class="info-row-1">
            <div class="info-pill-1 company-1"></div>
            <div class="info-pill-1 vendor-1"></div>
            <div class="info-pill-1 location-1"></div>
            <div class="info-pill-1 type-1"></div>
          </div>
          <div class="info-row-1">
            <div class="info-pill-1 salary-1"></div>
            <div class="info-pill-1 onsite-1"></div>
          </div>
        </div>
        <div class="status-1"></div>
      </div>

      <div class="footer-1">
        <div class="stat-1">
          <div class="stat-icon-1"></div>
          <div class="stat-text-1"></div>
        </div>
        <div class="stat-1">
          <div class="stat-icon-1"></div>
          <div class="stat-text-1"></div>
        </div>
        <div class="stat-1">
          <div class="stat-icon-1"></div>
          <div class="stat-text-1"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="timelinedesign" *ngIf="NameOftheScreen=='timelinedesign'">
  <div class="timeline-skeleton">
    <div class="timeline-item-skeleton" *ngFor="let item of countforView | times; let i = index">
      <div class="circle-skeleton skeleton"></div>
      <div class="content-skeleton">
        <div class="text-skeleton title skeleton"></div>
        <div class="text-skeleton date skeleton"></div>
      </div>
    </div>
  </div>
</div>
<div class="smallcarduidesign" *ngIf="NameOftheScreen=='smallcard'">
  <div class="job-list-skeleton">
    <div class="job-item-skeleton" *ngFor="let item of countforView | times; let i = index">
      <div class="checkbox-skeleton"></div>
      <div class="avatar-skeleton"></div>
      <div class="content-skeleton">
        <div class="text-skeleton title"></div>
        <div class="text-skeleton location"></div>
      </div>
    </div>
  </div>
</div>

<div class="likeviewcard" *ngIf="NameOftheScreen=='likeviewcard'">
  <div class="card-skeleton mb-10" *ngFor="let item of countforView | times; let i = index">
    <div class="avatar-skeleton"></div>
    <div class="info-skeleton">
      <div class="text-skeleton name"></div>
      <div class="text-skeleton role"></div>
      <div class="text-skeleton timestamp"></div>
    </div>
    <div class="icon-skeleton"></div>
  </div>

</div>

<div class="candidateDetails" *ngIf="NameOftheScreen=='candidateDetails'">

  <div class="page-skeleton">
    <div class="section-skeleton" *ngFor="let item of countforView | times; let i = index">
      <div class="header-skeleton">
        <div class="text-skeleton header"></div>
        <div class="icons-skeleton">
          <div class="icon-skeleton"></div>
          <div class="icon-skeleton"></div>
        </div>
      </div>
      <div class="content-skeleton">
        <div class="text-skeleton content-line"></div>
        <div class="text-skeleton content-line"></div>
      </div>
    </div>
  </div>



</div>
<!-- Skeleton Loader for Table -->
<div *ngIf="NameOftheScreen == 'billingHistory'" class="billing-history-skeleton">
  <table class="skeleton-table">
    <thead>
      <tr>
        <th *ngFor="let header of [].constructor(6)">
          <div class="skeleton skeleton-header"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of [].constructor(countforView)">
        <td *ngFor="let header of [].constructor(6)">
          <div class="skeleton skeleton-cell"></div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- usercarddesign -->
<div class="hpanel contact-panel usercard-skeleton" *ngIf="NameOftheScreen == 'usercard'">
  <div class="panel-body cp jsoh border-radius-top-left-right-6 border-radius-bottom-left-right-0">
    <div class="row">
      <div class="col-sm-4">
        <div class="img-circle skeleton-img"></div>
      </div>
      <div class="col-sm-8 skdh0">
        <div class="skeleton-text skeleton-btn"></div>

        <div class="btn-group skeleton-btn-group" style="margin-top: 10px;"></div>
      </div>
      <div class="col-sm-12 rmlft">
        <div class="talha">
          <div class="skeleton-text skeleton-subtitle"></div>
          <div class="skeleton-text skeleton-subtitle"></div>
          <div class="skeleton-text skeleton-subtitle"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="panel-footer contact-footer lahfp border-radius-top-left-right-0">
    <div class="row">
      <div class="col-md-6 border-right">
        <div class="skeleton-text skeleton-footer-text"></div>
      </div>
      <div class="col-md-6">
        <div class="skeleton-text skeleton-footer-text"></div>
      </div>
    </div>
  </div>
</div>
<!-- user card, variant 'wireframe' (business Employees / Manage Employees). Mirrors the
     .uc-wf-card layout in user-card; the 'usercard' skeleton above is unchanged. -->
<div class="ucw-skel" *ngIf="NameOftheScreen == 'usercardWireframe'">
  <div class="ucw-skel-body">
    <div class="ucw-sk ucw-skel-av"></div>
    <div class="ucw-skel-main">
      <div class="ucw-sk ucw-skel-name"></div>
      <div class="ucw-skel-row"><span class="ucw-sk ucw-skel-ico"></span><span class="ucw-sk ucw-skel-line ucw-w70"></span></div>
      <div class="ucw-skel-row"><span class="ucw-sk ucw-skel-ico"></span><span class="ucw-sk ucw-skel-line ucw-w55"></span></div>
      <div class="ucw-skel-row"><span class="ucw-sk ucw-skel-ico"></span><span class="ucw-sk ucw-skel-line ucw-w45"></span></div>
    </div>
  </div>
  <div class="ucw-skel-footer">
    <div class="ucw-skel-foot"><span class="ucw-sk ucw-skel-foot-line"></span></div>
    <div class="ucw-skel-divider"></div>
    <div class="ucw-skel-foot"><span class="ucw-sk ucw-skel-foot-line"></span></div>
  </div>
</div>
<!-- network card -->
<div *ngIf="NameOftheScreen == 'networkcard'">
  <div class="hpanel contact-panel networkcard-skeleton">
    <div class="panel-body border-radius-top-left-right-6 border-radius-bottom-left-right-0 min-12-rem">
      <!-- Network Name Placeholder -->
      <div class="network-card-header">
        <div class="skeleton-text skeleton-title"></div>
      </div>
      <!-- Message Placeholder -->
      <div class="network-card-body">
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
      </div>
    </div>
    <!-- Footer with 3 divisions -->
    <div class="panel-footer contact-footer border-radius-top-left-right-0">
      <div class="row">
        <div class="col-md-4">
          <div class="skeleton-text skeleton-footer-text"></div>
        </div>
        <div class="col-md-4">
          <div class="skeleton-text skeleton-footer-text"></div>
        </div>
        <div class="col-md-4">
          <div class="skeleton-text skeleton-footer-text"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="NameOftheScreen == 'teamcard'">
  <div class="hpanel contact-panel networkcard-skeleton">
    <div class="panel-body border-radius-top-left-right-6 border-radius-bottom-left-right-0 min-12-8-rem">
      <!-- Network Name Placeholder -->
      <div class="network-card-header">
        <div class="skeleton-text skeleton-title"></div>
      </div>
      <!-- Message Placeholder -->
      <div class="network-card-body">
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
        <div class="skeleton-text skeleton-subtitle"></div>
      </div>
    </div>
    <!-- Footer with 3 divisions -->
    <div class="panel-footer contact-footer border-radius-top-left-right-0">
      <div class="row">
        <div class="col-md-4">
          <div class="skeleton-text skeleton-footer-text"></div>
        </div>
        <div class="col-md-4">
          <div class="skeleton-text skeleton-footer-text"></div>
        </div>
        <div class="col-md-4">
          <div class="skeleton-text skeleton-footer-text"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="NameOftheScreen == 'planDetails'">
  <div class="skeleton-container">
    <div class="skeleton-table">
      <div class="skeleton-table-header">
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
      </div>

      <div class="skeleton-table-row" *ngFor="let row of getRows()">
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
        <div class="skeleton-table-cell skeleton"></div>
      </div>
    </div>
  </div>
</div>


<!-- Job list (extra-small) — Candidate Invite "My Jobs" list AND Job Apply.
     Both render <app-jobs viewSize="extra-small"> whose card is
     .hpanel.mr-bt-0.e-small > .xs-job-entity-container: checkbox · 50px circle
     avatar · job title + location. Mirror that tall bordered card so the
     placeholder occupies the same box (no shift on load). -->
<div *ngIf="NameOftheScreen == 'JobPopup'" class="job-invite-xs-loader">
  <ng-container *ngFor="let item of countforView | times; let i = index">
    <div class="jix-card">
      <div class="jix-check sk"></div>
      <div class="jix-avatar sk"></div>
      <div class="jix-info">
        <div class="jix-title sk"></div>
        <div class="jix-location sk"></div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Apply flow — placeholder mirrors the "My Candidates" apply card
     (checkbox · avatar · name/org · pay-rate input · currency · type
     dropdown · status pill) so the loader matches candidates-page's
     extra-small apply card with no layout shift on load. -->
<div *ngIf="NameOftheScreen == 'applyCandidateXs'" class="apply-candidate-xs-loader">
  <ng-container *ngFor="let item of countforView | times; let i = index">
    <div class="ac-card">
      <div class="ac-details">
        <div class="ac-check sk"></div>
        <div class="ac-avatar sk"></div>
        <div class="ac-info">
          <div class="ac-name sk"></div>
          <div class="ac-title sk"></div>
        </div>
      </div>
      <div class="ac-rate-group">
        <div class="ac-rate sk"></div>
        <div class="ac-type sk"></div>
      </div>
      <div class="ac-status sk"></div>
    </div>
  </ng-container>
</div>

<!-- //message module mid section -->
<div *ngIf="NameOftheScreen === 'Chatmidsection'" class="chat-container">
  <div class="chat-header">
    <!-- Left Side: Profile & Name -->
    <div class="header-left">
      <div class="skeleton skeleton-profile"></div>
      <div class="skeleton skeleton-name"></div>
    </div>
    <!-- Middle: Search Box -->
    <div class="header-middle">
      <div class="skeleton skeleton-search"></div>
    </div>
</div>

  <!-- Chat Messages Skeleton Loader (Mid Section) -->
  <div class="chat-messages">
    <div *ngFor="let i of skeletonArray" class="skeleton-message-wrapper"
         [ngClass]="{'left': i % 2 === 0, 'right': i % 2 !== 0}">

      <!-- Profile Image Skeleton for both Left & Right -->
      <div class="skeleton skeleton-avatar"></div>

      <!-- Message Bubble Skeleton -->
      <div class="skeleton skeleton-message"
           [ngStyle]="{'width': getMessageWidth(i) + 'px'}">
      </div>


    </div>
  </div>
  <!-- Footer Section -->
  <div class="chat-footer">
    <div class="skeleton skeleton-attach"></div>
    <div class="skeleton skeleton-input"></div>
    <div class="skeleton skeleton-send"></div>
  </div>

</div>

<div *ngIf="NameOftheScreen === 'widget-counter'"  class="container007">
        <div class="card007">
          <div class="skeleton007 number007"></div>
          <div class="skeleton007 title007"></div>
        </div>
        
        <div class="card007">
          <div class="skeleton007 number007"></div>
          <div class="skeleton007 title007"></div>
        </div>
        
        <div class="card007">
          <div class="skeleton007 number007"></div>
          <div class="skeleton007 title007"></div>
        </div>
        
        <div class="card007">
          <div class="skeleton007 number007"></div>
          <div class="skeleton007 title007"></div>
        </div>
        
        <div class="card007">
          <div class="skeleton007 number007"></div>
          <div class="skeleton007 title007"></div>
        </div>
    </div>





  <div *ngIf="NameOftheScreen === 'notification-config'" class="skeleton-tables-wrapper">
    <div class="skeleton-table-card" *ngFor="let card of [1, 2]">
      <div class="skeleton-header-row">
        <div class="skeleton-cell header small"></div>
        <div class="skeleton-cell header"></div>
        <div class="skeleton-cell header small"></div>
        <div class="skeleton-cell header small"></div>
      </div>

      <div class="skeleton-body-row" *ngFor="let i of [1, 2, 3]">
        <div class="skeleton-cell small"></div>
        <div class="skeleton-cell medium"></div>
        <div class="skeleton-cell checkbox"></div>
        <div class="skeleton-cell checkbox"></div>
      </div>
    </div>
    
  </div>

  <div class="hpanel contact-panel usercard-skeleton" *ngIf="NameOftheScreen == 'timeline'">
    <div class="panel-body cp jsoh border-radius-top-left-right-6 border-radius-bottom-left-right-0">
      <div class="row">
        <div class="col-sm-12 rmlft">
          <div class="talha">
            <div class="skeleton-text skeleton-subtitle"></div>
          </div>
        </div>
      </div>
    </div>
  </div>





